import * as React from 'react';
import './launch-notes.scss';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'launchnotes-embed': any;
    }
  }
}
interface Props {
  userId: number;
}

const LaunchNotes = ({ userId }: Props) => (
  <launchnotes-embed
    token="public_kstYzKLJU98bVgkViG9Adzrn"
    project="pro_dPbZHedFCfIeq"
    toggle-selector="div[role=button]:has(#whatsnew-notifications-launch-notes)"
    heading="TeamSnap Updates"
    heading-color="#FFF"
    subheading="News & Updates from the TeamSnap Team"
    subheading-color="rgba(255, 255, 255, 0.8)"
    primary-color="#0f52ba"
    widget-placement="auto"
    widget-offset-skidding="0"
    widget-offset-distance="0"
    show-unread
    anonymous-user-id={userId}
    unread-placement="right-start"
    unread-background-color="#ff8f00"
    unread-text-color="#ff8f00"
    unread-offset-distance="4"
  />
);

export default LaunchNotes;
